import Intercom, {shutdown} from '@intercom/messenger-js-sdk'
import {UserModel} from 'app/features/auth/models/UserModel'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from 'setup'

const IntercomSDK = (): any => {
  const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel

  const company = {
    id: user.email,
    name: user.store?.name,
  }

  return Intercom({
    app_id: 'aypj9f4e',
    user_id: user.store?.name,
    name: `${user.firstName} ${user.lastName}`,
    email: user.email,
    company,
    companies: [company],
  })
}
export default IntercomSDK

export const clearIntercomSession = () => {
  shutdown()
}
